import { Injectable } from '@angular/core';
import { CommonService } from './common.service';
import { environment } from '../../environments/environment';
import { locale } from 'moment/moment';
import { catchError, map, take, throwError } from 'rxjs';
import { AvailableLangs, TranslocoService } from '@ngneat/transloco';
import {
    HttpClient,
    HttpHeaders,
    HttpParams,
    HttpResponse,
} from '@angular/common/http';
import { apiConfig } from '../api-url.config';
import { AlertService } from 'app/shared/alert/alert.service';
import { AuthService } from 'app/core/auth/auth.service';

@Injectable({
    providedIn: 'root',
})
export class DashboardService extends CommonService {
    API_END_POINT: string;
    ANTON_API_END_POINT: string;
    loggedInUser = localStorage.getItem('loggedInUser')
        ? JSON.parse(localStorage.getItem('loggedInUser'))
        : undefined;
    translations = JSON.parse(localStorage.getItem('translations'));
    availableLangs: AvailableLangs;

    constructor(
        private httpClient: HttpClient,
        private _translocoService: TranslocoService,
        private alertService: AlertService,
        private authService: AuthService,
    ) {
        super();
        this.API_END_POINT = environment.API_END_POINT;
        this.ANTON_API_END_POINT = environment.ANTON_API_END_POINT;
        if (!this.translations) {
            let selectedLanguageId = this.getSelectedLanguage();
            this.fetchLanguageTranslations(selectedLanguageId);
        }
    }

    /*date filter in dashboard */
    /*getDashboardData(search: any) {
        let params = this.generateHttpParams(search);*/
    getDashboardData(site_id) {
        let params = this.generateHttpParams({
            site_id: site_id,
        });
        return this.httpClient
            .get(
                `${this.API_END_POINT}${apiConfig.dashboardWidgets.totalWidgets}`,
                { params },
            )
            .pipe(
                map((res: any) => res),
                catchError((err: any) => {
                    return throwError(err.error);
                }),
            );
    }

    getMasterSiteInfo() {
        localStorage.setItem('getMasterSiteInfoCallCount', '1');
        const loggedInUser = localStorage.getItem('loggedInUser')
            ? JSON.parse(localStorage.getItem('loggedInUser'))
            : undefined;
        const orgId = loggedInUser?.org_id;
        let params = this.generateHttpParams({
            org_id: orgId,
        });
        return this.httpClient
            .get(`${this.API_END_POINT}${apiConfig.shiftData.getMasterSite}`, {
                params,
            })
            .pipe(
                map((res: any) => res),
                catchError((err: any) => {
                    return throwError(err.error);
                }),
            );
        // }
    }

    generateShiftDataPdf(
        search: any,
        fileName,
        isUnique: boolean = false,
        isDayNight: string = 'both',
        isShoulderMedian: any,
        LaneValue: string = 'both',
    ) {
        let params = this.generateHttpParams(search);
        let headers = new HttpHeaders({
            Accept: 'application/pdf',
            timeout: '1020000',
            isHiderSpinner: 'true',
        });
        let url = '';
        if (isDayNight === 'both') {
            if (
                LaneValue === ' ' ||
                LaneValue === null ||
                LaneValue === undefined ||
                LaneValue === ''
            ) {
                url = `${this.API_END_POINT}${apiConfig.shiftData.generateShiftDataPdf}?isUnique=${isUnique}&isShoulderMedian=${isShoulderMedian}`;
            } else {
                url = `${this.API_END_POINT}${apiConfig.shiftData.generateShiftDataPdf}?isUnique=${isUnique}&isShoulderMedian=${isShoulderMedian}&serviceLane=${LaneValue}`;
            }
        } else {
            if (
                LaneValue === ' ' ||
                LaneValue === null ||
                LaneValue === undefined ||
                LaneValue === ''
            ) {
                url = `${this.API_END_POINT}${apiConfig.shiftData.generateShiftDataPdf}?isUnique=${isUnique}&isDayNight=${isDayNight}&isShoulderMedian=${isShoulderMedian}`;
            } else {
                url = `${this.API_END_POINT}${apiConfig.shiftData.generateShiftDataPdf}?isUnique=${isUnique}&isDayNight=${isDayNight}&isShoulderMedian=${isShoulderMedian}&serviceLane=${LaneValue}`;
            }
        }
        /*WO anomaly and completed filter changes */
        let isAnomaly = 0;
        if (search.anomalyStatus && search.anomalyStatus.length == 1) {
            isAnomaly = search.anomalyStatus[0] === 'Anomaly' ? 1 : 0;
            url += `&isAnomaly=${isAnomaly}`;
        }
        return this.httpClient
            .get(url, {
                params,
                headers,
                responseType: 'blob' as 'blob',
                observe: 'response',
            })
            .pipe(
                map((response: HttpResponse<any>) => {
                    response.headers.keys().forEach((key) => {});
                    let blob = new Blob([response.body], {
                        type: 'application/pdf', // must match the Accept type
                        // type: 'application/octet-stream' // for excel
                    });

                    const contentDisposition = response.headers.get(
                        'Content-Disposition',
                    );
                    if (
                        contentDisposition &&
                        contentDisposition.includes('attachment')
                    ) {
                        const fileNameMatch =
                            contentDisposition.match(/filename="?([^"]+)"?/);
                        fileName = fileNameMatch ? fileNameMatch[1] : 'file';
                        var link = document.createElement('a');
                        link.href = window.URL.createObjectURL(blob);
                        link.download = fileName;
                        link.click();
                        window.URL.revokeObjectURL(link.href);
                        // this.alertService.clear('default-alert');
                    }
                }),
                catchError((err: any) => {
                    return throwError(err.error);
                }),
            );
    }
    generateShiftDataExcelFile(
        search: any,
        fileName,
        isUnique: boolean = false,
        isDayNight: string = 'both',
        isShoulderMedian: any,
        LaneValue: string = 'both',
    ) {
        let params = this.generateHttpParams(search);
        let headers = new HttpHeaders({
            Accept: 'application/vnd.ms-excel',
            timeout: '1020000',
            isHiderSpinner: 'true',
        });
        let url = '';
        if (isDayNight === 'both') {
            if (
                LaneValue === ' ' ||
                LaneValue === null ||
                LaneValue === undefined ||
                LaneValue === ''
            ) {
                url = `${this.ANTON_API_END_POINT}${apiConfig.shiftData.generateShiftDataExcelFile}?isUnique=${isUnique}&isShoulderMedian=${isShoulderMedian}`;
            } else {
                url = `${this.ANTON_API_END_POINT}${apiConfig.shiftData.generateShiftDataExcelFile}?isUnique=${isUnique}&isShoulderMedian=${isShoulderMedian}&serviceLane=${LaneValue}`;
            }
        } else {
            if (
                LaneValue === ' ' ||
                LaneValue === null ||
                LaneValue === undefined ||
                LaneValue === ''
            ) {
                url = `${this.ANTON_API_END_POINT}${apiConfig.shiftData.generateShiftDataExcelFile}?isUnique=${isUnique}&isDayNight=${isDayNight}&isShoulderMedian=${isShoulderMedian}`;
            } else {
                url = `${this.ANTON_API_END_POINT}${apiConfig.shiftData.generateShiftDataExcelFile}?isUnique=${isUnique}&isDayNight=${isDayNight}&isShoulderMedian=${isShoulderMedian}&serviceLane=${LaneValue}`;
            }
        }
        /*WO anomaly and completed filter changes */
        let isAnomaly = 0;
        if (search.anomalyStatus && search.anomalyStatus.length == 1) {
            isAnomaly = search.anomalyStatus[0] === 'Anomaly' ? 1 : 0;
            url += `&isAnomaly=${isAnomaly}`;
        }
        return this.httpClient
            .get(url, {
                params,
                headers,
                responseType: 'blob' as 'blob',
                observe: 'response',
            })
            .pipe(
                // map((res: any) => {
                //     let blob = new Blob([res], {
                //         type: 'application/vnd.ms-excel', // must match the Accept type
                //         // type: 'application/octet-stream' // for excel
                //     });
                //     var link = document.createElement('a');
                //     link.href = window.URL.createObjectURL(blob);
                //     link.download = fileName + '.xlsx';
                //     link.click();
                //     window.URL.revokeObjectURL(link.href);
                //     this.alertService.clear('default-alert');
                // }),
                // catchError((err: any) => {
                //     return throwError(err.error);
                // })
                map((response: HttpResponse<any>) => {
                    response.headers.keys().forEach((key) => {});
                    let blob = new Blob([response.body], {
                        type: 'application/pdf', // must match the Accept type
                        // type: 'application/octet-stream' // for excel
                    });

                    const contentDisposition = response.headers.get(
                        'Content-Disposition',
                    );
                    if (
                        contentDisposition &&
                        contentDisposition.includes('attachment')
                    ) {
                        const fileNameMatch =
                            contentDisposition.match(/filename="?([^"]+)"?/);
                        fileName = fileNameMatch ? fileNameMatch[1] : 'file';
                        var link = document.createElement('a');
                        link.href = window.URL.createObjectURL(blob);
                        link.download = fileName;
                        link.click();
                        window.URL.revokeObjectURL(link.href);
                        // this.alertService.clear('default-alert');
                    }
                }),
                catchError((err: any) => {
                    return throwError(err.error);
                }),
            );
    }
    generateMasterExcelFile(search: any, fileName) {
        let params = this.generateHttpParams(search);
        let headers = new HttpHeaders({
            Accept: 'application/vnd.ms-excel',
            timeout: '1020000',
            isHiderSpinner: 'true',
        });
        //serviceLane ,export changes
        let serviceLane = localStorage.getItem('ServiceLaneMCW');
        let loggedInUser = localStorage.getItem('loggedInUser')
            ? JSON.parse(localStorage.getItem('loggedInUser'))
            : undefined;
        let url;
        if (
            serviceLane === 'null' ||
            serviceLane === null ||
            !this.getMCWServiceLaneValue()
        ) {
            url = `${this.ANTON_API_END_POINT}${apiConfig.shiftData.generateMasterExcelFile}`;
        } else {
            url = `${this.ANTON_API_END_POINT}${apiConfig.shiftData.generateMasterExcelFile}?serviceLane=${serviceLane}`;
        }
        return this.httpClient
            .get(url, {
                params,
                headers,
                responseType: 'blob' as 'blob',
                observe: 'response',
            })
            .pipe(
                // map((res: any) => {
                //     let blob = new Blob([res], {
                //         type: 'application/vnd.ms-excel', // must match the Accept type
                //         // type: 'application/octet-stream' // for excel
                //     });
                //     var link = document.createElement('a');
                //     link.href = window.URL.createObjectURL(blob);
                //     link.download = fileName + '.xlsx';
                //     link.click();
                //     window.URL.revokeObjectURL(link.href);
                //     this.alertService.clear('default-alert');
                // }),
                // catchError((err: any) => {
                //     return throwError(err.error);
                // })
                map((response: HttpResponse<any>) => {
                    response.headers.keys().forEach((key) => {});
                    let blob = new Blob([response.body], {
                        type: 'application/pdf', // must match the Accept type
                        // type: 'application/octet-stream' // for excel
                    });

                    const contentDisposition = response.headers.get(
                        'Content-Disposition',
                    );
                    if (
                        contentDisposition &&
                        contentDisposition.includes('attachment')
                    ) {
                        const fileNameMatch =
                            contentDisposition.match(/filename="?([^"]+)"?/);
                        fileName = fileNameMatch ? fileNameMatch[1] : 'file';
                        var link = document.createElement('a');
                        link.href = window.URL.createObjectURL(blob);
                        link.download = fileName;
                        link.click();
                        window.URL.revokeObjectURL(link.href);
                        // this.alertService.clear('default-alert');
                    }
                }),
                catchError((err: any) => {
                    return throwError(err.error);
                }),
            );
    }
    generateShiftDataShapeFile(
        search: any,
        fileName,
        isUnique: boolean = false,
        isDayNight: string = 'both',
        LaneValue: string = 'both',
    ) {
        let params = this.generateHttpParams(search);
        let headers = new HttpHeaders({
            Accept: 'application/zip',
            timeout: '1020000',
            isHiderSpinner: 'true',
        });
        let url = '';
        if (isDayNight === 'both') {
            if (
                LaneValue === ' ' ||
                LaneValue === null ||
                LaneValue === undefined ||
                LaneValue === ''
            ) {
                url = `${this.API_END_POINT}${apiConfig.shiftData.generateShiftDataShapefile}?isUnique=${isUnique}`;
            } else {
                url = `${this.API_END_POINT}${apiConfig.shiftData.generateShiftDataShapefile}?isUnique=${isUnique}&serviceLane=${LaneValue}`;
            }
        } else {
            if (
                LaneValue === ' ' ||
                LaneValue === null ||
                LaneValue === undefined ||
                LaneValue === ''
            ) {
                url = `${this.API_END_POINT}${apiConfig.shiftData.generateShiftDataShapefile}?isUnique=${isUnique}&isDayNight=${isDayNight}`;
            } else {
                url = `${this.API_END_POINT}${apiConfig.shiftData.generateShiftDataShapefile}?isUnique=${isUnique}&isDayNight=${isDayNight}&serviceLane=${LaneValue}`;
            }
        }
        /*WO anomaly and completed filter changes */
        let isAnomaly = 0;
        if (search.anomalyStatus && search.anomalyStatus.length == 1) {
            isAnomaly = search.anomalyStatus[0] === 'Anomaly' ? 1 : 0;
            url += `&isAnomaly=${isAnomaly}`;
        }
        return this.httpClient
            .get(url, {
                params,
                headers,
                responseType: 'blob' as 'blob',
                observe: 'response',
            })
            .pipe(
                // map((res: any) => {
                //     let blob = new Blob([res], {
                //         type: 'application/zip', // must match the Accept type
                //         // type: 'application/octet-stream' // for excel
                //     });
                //     var link = document.createElement('a');
                //     link.href = window.URL.createObjectURL(blob);
                //     link.download = fileName + '.zip';
                //     link.click();
                //     window.URL.revokeObjectURL(link.href);
                //     this.alertService.clear('default-alert');
                // }),
                // catchError((err: any) => {
                //     return throwError(err.error);
                // })
                map((response: HttpResponse<any>) => {
                    response.headers.keys().forEach((key) => {});
                    let blob = new Blob([response.body], {
                        type: 'application/pdf', // must match the Accept type
                        // type: 'application/octet-stream' // for excel
                    });

                    const contentDisposition = response.headers.get(
                        'Content-Disposition',
                    );
                    if (
                        contentDisposition &&
                        contentDisposition.includes('attachment')
                    ) {
                        const fileNameMatch =
                            contentDisposition.match(/filename="?([^"]+)"?/);
                        fileName = fileNameMatch ? fileNameMatch[1] : 'file';
                        var link = document.createElement('a');
                        link.href = window.URL.createObjectURL(blob);
                        link.download = fileName;
                        link.click();
                        window.URL.revokeObjectURL(link.href);
                        // this.alertService.clear('default-alert');
                    }
                }),
                catchError((err: any) => {
                    return throwError(err.error);
                }),
            );
    }
    generateMasterDataShapeFile(search: any, fileName) {
        let params = this.generateHttpParams(search);
        let headers = new HttpHeaders({
            Accept: 'application/zip',
            timeout: '1020000',
            isHiderSpinner: 'true',
        });
        //serviceLane ,export changes
        let serviceLane = localStorage.getItem('ServiceLaneMCW');
        let loggedInUser = localStorage.getItem('loggedInUser')
            ? JSON.parse(localStorage.getItem('loggedInUser'))
            : undefined;
        let url;
        if (
            serviceLane === 'null' ||
            serviceLane === null ||
            !this.getMCWServiceLaneValue()
        ) {
            url = `${this.API_END_POINT}${apiConfig.masterData.generateMasterDataShapefile}`;
        } else {
            url = `${this.API_END_POINT}${apiConfig.masterData.generateMasterDataShapefile}?serviceLane=${serviceLane}`;
        }
        return this.httpClient
            .get(url, {
                params,
                headers,
                responseType: 'blob' as 'blob',
                observe: 'response',
            })
            .pipe(
                // map((res: any) => {
                //     let blob = new Blob([res], {
                //         type: 'application/zip', // must match the Accept type
                //         // type: 'application/octet-stream' // for excel
                //     });
                //     var link = document.createElement('a');
                //     link.href = window.URL.createObjectURL(blob);
                //     link.download = fileName + '.zip';
                //     link.click();
                //     window.URL.revokeObjectURL(link.href);
                //     this.alertService.clear('default-alert');
                // }),
                // catchError((err: any) => {
                //     return throwError(err.error);
                // })
                map((response: HttpResponse<any>) => {
                    response.headers.keys().forEach((key) => {});
                    let blob = new Blob([response.body], {
                        type: 'application/pdf', // must match the Accept type
                        // type: 'application/octet-stream' // for excel
                    });

                    const contentDisposition = response.headers.get(
                        'Content-Disposition',
                    );
                    if (
                        contentDisposition &&
                        contentDisposition.includes('attachment')
                    ) {
                        const fileNameMatch =
                            contentDisposition.match(/filename="?([^"]+)"?/);
                        fileName = fileNameMatch ? fileNameMatch[1] : 'file';
                        var link = document.createElement('a');
                        link.href = window.URL.createObjectURL(blob);
                        link.download = fileName;
                        link.click();
                        window.URL.revokeObjectURL(link.href);
                        // this.alertService.clear('default-alert');
                    }
                }),
                catchError((err: any) => {
                    return throwError(err.error);
                }),
            );
    }

    generateMasterDataPdf(search: any, fileName) {
        let params = this.generateHttpParams(search);
        let headers = new HttpHeaders({
            Accept: 'application/pdf',
            timeout: '1020000',
            isHiderSpinner: 'true',
        });
        //serviceLane ,export changes
        let serviceLane = localStorage.getItem('ServiceLaneMCW');
        let loggedInUser = localStorage.getItem('loggedInUser')
            ? JSON.parse(localStorage.getItem('loggedInUser'))
            : undefined;
        let url;
        if (
            serviceLane === 'null' ||
            serviceLane === null ||
            !this.getMCWServiceLaneValue()
        ) {
            url = `${this.API_END_POINT}${apiConfig.shiftData.generateMasterDataPdf}`;
        } else {
            url = `${this.API_END_POINT}${apiConfig.shiftData.generateMasterDataPdf}?serviceLane=${serviceLane}`;
        }
        return this.httpClient
            .get(url, {
                params,
                headers,
                responseType: 'blob' as 'blob',
                observe: 'response',
            })
            .pipe(
                // map((res: any) => {
                //     let blob = new Blob([res], {
                //         type: 'application/pdf', // must match the Accept type
                //         // type: 'application/octet-stream' // for excel
                //     });
                //     var link = document.createElement('a');
                //     link.href = window.URL.createObjectURL(blob);
                //     link.download = fileName + '.pdf';
                //     link.click();
                //     window.URL.revokeObjectURL(link.href);
                //     this.alertService.clear('default-alert');
                // }),
                // catchError((err: any) => {
                //     return throwError(err.error);
                // })
                map((response: HttpResponse<any>) => {
                    response.headers.keys().forEach((key) => {});
                    let blob = new Blob([response.body], {
                        type: 'application/pdf', // must match the Accept type
                        // type: 'application/octet-stream' // for excel
                    });

                    const contentDisposition = response.headers.get(
                        'Content-Disposition',
                    );
                    if (
                        contentDisposition &&
                        contentDisposition.includes('attachment')
                    ) {
                        const fileNameMatch =
                            contentDisposition.match(/filename="?([^"]+)"?/);
                        fileName = fileNameMatch ? fileNameMatch[1] : 'file';
                        var link = document.createElement('a');
                        link.href = window.URL.createObjectURL(blob);
                        link.download = fileName;
                        link.click();
                        window.URL.revokeObjectURL(link.href);
                        // this.alertService.clear('default-alert');
                    }
                }),
                catchError((err: any) => {
                    return throwError(err.error);
                }),
            );
    }

    getAssetTypesInAssets() {
        return this.httpClient
            .get(
                `${this.API_END_POINT}${apiConfig.shiftData.getAssetTypesInAssets}`,
            )
            .pipe(
                map((res: any) => res),
                catchError((err: any) => {
                    return throwError(err.error);
                }),
            );
    }

    /*shoulder median changes */
    getAllShiftData(
        site_id: any,
        search,
        isShoulderMedian: string,
        issueType: any,
        isUnique: boolean = false,
        chainageRange: any = [],
        isDayNight: any = 'both',
        serviceLane: any = '',
    ) {
        search.site_ids = site_id;
        if (this.loggedInUser.org_id === 192) {
            delete search.chainage;
        }
        delete search.issueType;
        const encodedChainage = encodeURIComponent(
            JSON.stringify(chainageRange),
        );
        let params = this.generateHttpParams(search);
        // shoulder median changes
        let url = `${this.API_END_POINT}${apiConfig.shiftData.getAllShiftDataV2}?${params}`;
        url += `&isShoulderMedian=${isShoulderMedian}&isUnique=${isUnique}`;

        // Normalize input values
        const hasChainage =
            chainageRange &&
            chainageRange !== '[]' &&
            chainageRange !== '{}' &&
            chainageRange !== '' &&
            chainageRange.length > 0;
        const hasIssueType =
            issueType &&
            issueType !== '' &&
            issueType !== ' ' &&
            issueType !== null &&
            issueType !== undefined &&
            issueType.length > 0;
        const isDayNightFiltered = isDayNight !== 'both' || isDayNight !== '';
        const isServiceLane = serviceLane !== '' || serviceLane !== 'both';
        /*WO anomaly and completed filter changes */
        let isAnomaly = 0;
        if (search.anomalyStatus && search.anomalyStatus.length == 1) {
            isAnomaly = search.anomalyStatus[0] === 'Anomaly' ? 1 : 0;
            url += `&isAnomaly=${isAnomaly}`;
        }
        if (hasChainage) {
            url += `&chainageRange=${encodedChainage}`;
        }
        if (hasIssueType) {
            url += `&issueType=${issueType}`;
        }
        if (isDayNightFiltered) {
            url += `&isDayNight=${isDayNight}`;
        }
        if (isServiceLane) {
            url += `&serviceLane=${serviceLane}`;
        }
        return this.httpClient.get(url).pipe(
            map((res: any) => res),
            catchError((err: any) => {
                return throwError(err.error);
            }),
        );
    }

    /* shoulder median changes*/
    /*MCW and Service Lanes filter changes */
    getAllMasterData(
        site_id: any,
        search,
        isShoulderMedian: string,
        serviceLane: any = null,
        chainageRange: any = [],
    ) {
        search.site_ids = site_id;
        if (this.loggedInUser.org_id === 192) {
            delete search.chainage;
        }
        const encodedChainage = encodeURIComponent(
            JSON.stringify(chainageRange),
        );
        let params = this.generateHttpParams(search);
        /*MCW and Service Lanes filter changes */
        let url: any;

        if (serviceLane === null || !this.getMCWServiceLaneValue()) {
            //shoulder median changes
            if (
                chainageRange === null ||
                chainageRange == '[]' ||
                chainageRange === '' ||
                chainageRange === '{}' ||
                chainageRange.length === 0
            ) {
                url = `${this.API_END_POINT}${apiConfig.shiftData.getAllMasterDataV2}?isShoulderMedian=${isShoulderMedian}`;
            } else {
                url = `${this.API_END_POINT}${apiConfig.shiftData.getAllMasterDataV2}?isShoulderMedian=${isShoulderMedian}&chainageRange=${encodedChainage}`;
            }
        } else {
            if (
                chainageRange === null ||
                chainageRange == '[]' ||
                chainageRange === '' ||
                chainageRange === '{}' ||
                chainageRange.length === 0
            ) {
                //shoulder median changes
                url = `${this.API_END_POINT}${apiConfig.shiftData.getAllMasterDataV2}?isShoulderMedian=${isShoulderMedian}&serviceLane=${serviceLane}`;
            } else {
                url = `${this.API_END_POINT}${apiConfig.shiftData.getAllMasterDataV2}?isShoulderMedian=${isShoulderMedian}&serviceLane=${serviceLane}&chainageRange=${encodedChainage}`;
            }
        }
        return this.httpClient
            .get(
                /*MCW and Service Lanes filter changes */
                url,
                { params },
            )
            .pipe(
                map((res: any) => res),
                catchError((err: any) => {
                    return throwError(err.error);
                }),
            );
    }

    getSiteAssetInfo(id, search) {
        let site_ids;
        if (search.site_ids) {
            search.site_id = search.site_ids;
            site_ids = search.site_ids;
            delete search.site_ids;
        }
        let params = this.generateHttpParams(search);
        let headers = new HttpHeaders({ isHiderSpinner: 'true' });
        return this.httpClient
            .get(
                `${this.API_END_POINT}${apiConfig.shiftData.getAllMasterData}/${id}`,
                { params, headers },
            )
            .pipe(
                map((res: any) => {
                    return this.reassignSiteIDToSiteIDs(res, site_ids, search);
                }),
                catchError((err: any) => {
                    return throwError(err.error);
                }),
            );
    }
    reassignSiteIDToSiteIDs(res: any, site_ids: any, search: any) {
        search.site_ids = site_ids;
        delete search.site_id;
        return res;
    }
    getShiftDataRecord(id, search) {
        let params = this.generateHttpParams(search);
        let headers = new HttpHeaders();

        return this.httpClient
            .get(
                `${this.API_END_POINT}${apiConfig.shiftData.getAllShiftData}/${id}`,
                { params, headers },
            )
            .pipe(
                map((res: any) => res),
                catchError((err: any) => {
                    return throwError(err.error);
                }),
            );
    }

    getMasterDataSummary(
        search: any,
        isShoulderMedian: any,
        serviceLane: any = null,
        chainageRange: any = [],
    ) {
        let params = this.generateHttpParams(search);
        let url: any;
        const encodedChainage = encodeURIComponent(
            JSON.stringify(chainageRange),
        );
        if (serviceLane === null || !this.getMCWServiceLaneValue()) {
            //shoulder median changes
            if (this.checkForValue(chainageRange)) {
                url = `${this.API_END_POINT}${apiConfig.shiftData.getMasterDataSummary}?isShoulderMedian=${isShoulderMedian}`;
            } else {
                url = `${this.API_END_POINT}${apiConfig.shiftData.getMasterDataSummary}?isShoulderMedian=${isShoulderMedian}&chainageRange=${encodedChainage}`;
            }
        } else {
            //shoulder median changes
            if (this.checkForValue(chainageRange)) {
                url = `${this.API_END_POINT}${apiConfig.shiftData.getMasterDataSummary}?isShoulderMedian=${isShoulderMedian}&serviceLane=${serviceLane}`;
            } else {
                url = `${this.API_END_POINT}${apiConfig.shiftData.getMasterDataSummary}?isShoulderMedian=${isShoulderMedian}&serviceLane=${serviceLane}&chainageRange=${encodedChainage}`;
            }
        }
        return this.httpClient.get(url, { params }).pipe(
            map((res: any) => res),
            catchError((err: any) => {
                return throwError(err.error);
            }),
        );
    }

    checkForValue(value: any) {
        if (
            value === '' ||
            value === ' ' ||
            value === null ||
            value === undefined ||
            value.length === 0
        ) {
            return true;
        }
        return false;
    }
    // getShiftDataSummary(search: any,isShoulderMedian:any,serviceLane : any = null,isUnique:boolean = true) {
    getShiftDataSummary(
        search: any,
        isShoulderMedian: any,
        isDayNight: string,
        issueType: any = [],
        serviceLane: any = null,
        isUnique: boolean = true,
        chainageRange: any = [],
    ) {
        delete search.issueType;
        let params = this.generateHttpParams(search);
        let url: string;
        const encodedChainage = encodeURIComponent(
            JSON.stringify(chainageRange),
        );
        /*WO anomaly and completed filter changes */
        const baseUrl = `${this.API_END_POINT}${apiConfig.shiftData.getShiftDataSummary}`;
        const queryParams: any = {
            isShoulderMedian,
            isUnique,
        };

        // Add serviceLane only if present
        if (serviceLane !== null) {
            queryParams.serviceLane = serviceLane;
        }

        // Add optional parameters based on conditions
        if (isDayNight !== 'both') {
            queryParams.isDayNight = isDayNight;
        }

        if (!this.checkForValue(issueType)) {
            queryParams.issueType = issueType;
        }

        if (!this.checkForValue(chainageRange)) {
            queryParams.chainageRange = encodedChainage;
        }

        let isAnomaly = 0;
        if (search.anomalyStatus && search.anomalyStatus.length == 1) {
            isAnomaly = search.anomalyStatus[0] === 'Anomaly' ? 1 : 0;
            queryParams.isAnomaly = isAnomaly;
        }

        // Construct query string dynamically
        const queryString = Object.entries(queryParams)
            .map(([key, val]) => `${key}=${val}`)
            .join('&');

        url = `${baseUrl}?${queryString}`;

        return this.httpClient.get(url, { params }).pipe(
            map((res: any) => res),
            catchError((err: any) => {
                return throwError(err.error);
            }),
        );
    }
    getSiteLatLongs(search: any) {
        let params = this.generateHttpParams(search);
        return this.httpClient
            .get(
                `${this.API_END_POINT}${apiConfig.trackingModule.siteLatlongs}`,
                { params },
            )
            .pipe(
                map((res: any) => res),
                catchError((err: any) => {
                    return throwError(err.error);
                }),
            );
    }
    getCoveredLatlongs(search: any) {
        let params = this.generateHttpParams(search);
        return this.httpClient
            .get(
                `${this.API_END_POINT}${apiConfig.trackingModule.coveredLatLongs}`,
                { params },
            )
            .pipe(
                map((res: any) => res),
                catchError((err: any) => {
                    return throwError(err.error);
                }),
            );
    }
    getDistanceStats(search: any, other_site_id: any) {
        let params = this.generateHttpParams(search);
        return this.httpClient
            .get(
                `${this.API_END_POINT}${apiConfig.trackingModule.distanceStats}?other_site_id=${other_site_id}`,
                { params },
            )
            .pipe(
                map((res: any) => res),
                catchError((err: any) => {
                    return throwError(err.error);
                }),
            );
    }
    getRangeOfChainageNotCovered(search: any) {
        let params = this.generateHttpParams(search);
        let headers = new HttpHeaders({ isHiderSpinner: 'true' });
        return this.httpClient
            .get(
                `${this.API_END_POINT}${apiConfig.trackingModule.uncoveredChainages}`,
                { params, headers },
            )
            .pipe(
                map((res: any) => res),
                catchError((err: any) => {
                    return throwError(err.error);
                }),
            );
    }

    fetchLanguageTranslations(languageId, reloadWindow = false) {
        this.getLanguageTranslations(languageId).subscribe((res) => {
            let data = res.responseData[0].records;
            localStorage.setItem('translations', JSON.stringify(data));
            if (reloadWindow) {
                setTimeout(() => {
                    window.location.reload();
                }, 100);
            }
        });
    }

    getSelectedLanguage() {
        let languages = localStorage.getItem('languages')
            ? JSON.parse(localStorage.getItem('languages'))
            : null;
        if (!languages) {
            // by default returning english language id which is 1
            return 1;
        }
        let selectedLanguageId =
            +localStorage.getItem('selected_language') || 1;
        return languages.find((l) => l.id === selectedLanguageId).id;
    }
    public translate(word: string) {
        if (!this.translations) {
            return word;
        }
        return (
            this.translations.find(
                (t) =>
                    String(t.key).toLowerCase() == String(word).toLowerCase(),
            )?.translation || word
        );
        // let text = '';
        // let isTranslated = false;
        // this._translocoService
        //     .selectTranslate(word)
        //     .pipe(take(1))
        //     .subscribe((translation) => {
        //         text = translation;
        //         isTranslated = true;
        //     });
        // return text;
    }
    public translateAllWords(s: string) {
        // first trying if same text has the same
        // let translatedText = '';
        if (!this.translations) {
            return s;
        }
        let translatedText =
            this.translations.find(
                (t) => String(t.key).toLowerCase() == String(s).toLowerCase(),
            )?.translation || s;

        // this._translocoService
        //     .selectTranslate(s)
        //     .pipe(take(1))
        //     .subscribe((translation) => {
        //         translatedText = translation;
        //     });
        // if translated and argument text is same then splitting text and translating it.
        if (s && translatedText == s) {
            let splitData = s.split(' ');
            splitData.forEach((w, index) => {
                try {
                    let splitted_words = w.split('-');
                    splitted_words.forEach((sw, swIndex) => {
                        // this._translocoService
                        //     .selectTranslate(sw)
                        //     .pipe(take(1))
                        //     .subscribe((translation) => {
                        //         splitted_words[swIndex] = translation;
                        //     });
                        splitted_words[swIndex] =
                            this.translations.find(
                                (t) =>
                                    String(t.key).toLowerCase() ==
                                    String(sw).toLowerCase(),
                            )?.translation || sw;
                    });
                    splitData[index] = splitted_words.join('-');
                } catch (e) {
                    console.error(e);
                }
            });
            translatedText = splitData.join(' ');
        }
        if (
            (translatedText || s) ==
            'in this window, you can search for a specific location you want to see.'
        ) {
            translatedText =
                'In this window, you can search for a specific location you want to see.';
        }
        return translatedText || s;
    }

    getLanguages(site_id: any) {
        return this.httpClient
            .get(
                `${this.API_END_POINT}${apiConfig.utils.languages}?site_id=${site_id}`,
                {},
            )
            .pipe(
                map((res: any) => res),
                catchError((err: any) => {
                    return throwError(err.error);
                }),
            );
    }

    getLanguageTranslations(languageId) {
        return this.httpClient
            .get(
                `${this.API_END_POINT}${apiConfig.utils.languageTranslation}/${languageId}}`,
                {},
            )
            .pipe(
                map((res: any) => res),
                catchError((err: any) => {
                    return throwError(err.error);
                }),
            );
    }

    generateTrackingModuleExcelFile(
        site_id: any,
        periodFrom: any,
        periodTo: any,
        date: any,
    ) {
        let headers = new HttpHeaders({
            Accept: 'application/vnd.ms-excel',
            timeout: '1020000',
            isHiderSpinner: 'true',
        });
        let url = '';
        url = `${this.API_END_POINT}${apiConfig.trackingModule.exportTrackingModuleExcelfile}?site_id=${site_id}&periodFrom=${periodFrom}&periodTo=${periodTo}&date=${date}`;
        return this.httpClient
            .get(url, {
                headers,
                responseType: 'blob' as 'blob',
                observe: 'response',
            })
            .pipe(
                // map((res: any) => {
                //     let blob = new Blob([res], {
                //         type: 'application/vnd.ms-excel', // must match the Accept type
                //         // type: 'application/octet-stream' // for excel
                //     });
                //     var link = document.createElement('a');
                //     link.href = window.URL.createObjectURL(blob);
                //     link.download = fileName + '.xlsx';
                //     link.click();
                //     window.URL.revokeObjectURL(link.href);
                //     this.alertService.clear('default-alert');
                // }),
                // catchError((err: any) => {
                //     return throwError(err.error);
                // })
                map((response: HttpResponse<any>) => {
                    response.headers.keys().forEach((key) => {});
                    let blob = new Blob([response.body], {
                        type: 'application/pdf', // must match the Accept type
                        // type: 'application/octet-stream' // for excel
                    });

                    const contentDisposition = response.headers.get(
                        'Content-Disposition',
                    );
                    // if (
                    //     contentDisposition &&
                    //     contentDisposition.includes('attachment')
                    // ) {

                    //     const fileNameMatch =
                    //         contentDisposition.match(/filename="?([^"]+)"?/);
                    //     fileName = fileNameMatch ? fileNameMatch[1] : 'file';
                    //     var link = document.createElement('a');
                    //     link.href = window.URL.createObjectURL(blob);
                    //     link.download = fileName;
                    //     link.click();
                    //     window.URL.revokeObjectURL(link.href);
                    //     this.alertService.clear('default-alert');
                    // }
                }),
                catchError((err: any) => {
                    return throwError(err.error);
                }),
            );
    }

    generateWorkOrderExcelFile(
        search: any,
        fileName,
        isDayNight: string = 'both',
    ) {
        /*WO anomaly and completed filter changes */
        let manual_anomalies = 0;
        let AI_rejected = 0;
        let detected = 0;
        let auto_close_anomalies = undefined;

        // Safely handle detectionStatus
        if (Array.isArray(search?.detectionStatus)) {
            for (const element of search.detectionStatus) {
                switch (element) {
                    case 'manualSelected':
                        manual_anomalies = 1;
                        break;
                    case 'aiRejectedSelected':
                        AI_rejected = 1;
                        break;
                    case 'detectedSelected':
                        detected = 1;
                        break;
                }
            }
        }

        // Safely handle closureType
        console.log('search?.closureType', search?.closureType);
        if (
            Array.isArray(search?.closureType) &&
            search.closureType.length === 1
        ) {
            for (const element of search.closureType) {
                if (element === 'autoClosedSelected') {
                    auto_close_anomalies = 1;
                } else if (element === 'resolvedSelected') {
                    auto_close_anomalies = 0;
                }
            }
        }

        const params = this.generateHttpParams(search);
        const headers = new HttpHeaders({
            Accept: 'application/vnd.ms-excel',
            timeout: '1020000',
            isHiderSpinner: 'true',
        });

        let url = `${this.ANTON_API_END_POINT}${apiConfig.shiftData.generateWorkOrderExcelFile}?`;
        const queryParams = new URLSearchParams({
            manual_anomalies: manual_anomalies.toString(),
            AI_rejected: AI_rejected.toString(),
            detected: detected.toString(),
            ...(isDayNight !== 'both' && { isDayNight }),
        });

        if (auto_close_anomalies !== undefined)
            queryParams.set(
                'auto_close_anomalies',
                auto_close_anomalies.toString(),
            );

        url += queryParams.toString();

        return this.httpClient
            .get(url, {
                params,
                headers,
                responseType: 'blob' as 'blob',
                observe: 'response',
            })
            .pipe(
                // map((res: any) => {
                //     let blob = new Blob([res], {
                //         type: 'application/vnd.ms-excel', // must match the Accept type
                //         // type: 'application/octet-stream' // for excel
                //     });
                //     var link = document.createElement('a');
                //     link.href = window.URL.createObjectURL(blob);
                //     link.download = fileName + '.xlsx';
                //     link.click();
                //     window.URL.revokeObjectURL(link.href);
                //     this.alertService.clear('default-alert');
                // }),
                // catchError((err: any) => {
                //     return throwError(err.error);
                // })
                map((response: HttpResponse<any>) => {
                    response.headers.keys().forEach((key) => {});
                    let blob = new Blob([response.body], {
                        type: 'application/pdf', // must match the Accept type
                        // type: 'application/octet-stream' // for excel
                    });

                    const contentDisposition = response.headers.get(
                        'Content-Disposition',
                    );
                    if (
                        contentDisposition &&
                        contentDisposition.includes('attachment')
                    ) {
                        const fileNameMatch =
                            contentDisposition.match(/filename="?([^"]+)"?/);
                        fileName = fileNameMatch ? fileNameMatch[1] : 'file';
                        var link = document.createElement('a');
                        link.href = window.URL.createObjectURL(blob);
                        link.download = fileName;
                        link.click();
                        window.URL.revokeObjectURL(link.href);
                        // this.alertService.clear('default-alert');
                    }
                }),
                catchError((err: any) => {
                    return throwError(err.error);
                }),
            );
    }

    getDownloadDetails() {
        return this.httpClient
            .get(
                `${this.API_END_POINT}${apiConfig.dashboardWidgets.getDownloadDetails}`,
            )
            .pipe(
                map((res: any) => res),
                catchError((err: any) => {
                    return throwError(err.error);
                }),
            );
    }

    deleteDownloadRecord(id: any) {
        return this.httpClient
            .delete(
                `${this.API_END_POINT}${apiConfig.dashboardWidgets.deleteDownloadRecord}/${id}`,
            )
            .pipe(
                map((res: any) => res),
                catchError((err: any) => {
                    return throwError(err.error);
                }),
            );
    }

    deleteMasterRecord(id: string, site_ids: string[]) {
        const url = `${this.API_END_POINT}${apiConfig.masterData.deleteMasterRecord}`;
        const params = {
            master_id: id,
            site_ids: site_ids.join(','),
        };
        return this.httpClient.post(url, params).pipe(
            map((res: any) => res),
            catchError((err: any) => {
                return throwError(err.error);
            }),
        );
    }

    //button to mark given master as 'Not our Asset'

    /*deleteMasterData(site_id: string, master_id: string) {
          const params = {
            site_id: site_id,
            master_id: master_id
          };
          return  this.httpClient
          .delete(`${this.API_END_POINT}${apiConfig.masterData.deleteSiteAssetFromMaster}`,
            { body: params}) 
            .pipe(
                map((res: any) => res),
                catchError((err: any) => {
                    return throwError(err.error);
                })
            );
    }*/

    getAssetData(site_id: any) {
        let url;
        url = `${this.API_END_POINT}${apiConfig.department.getAssetData}`;
        return this.httpClient.get<any>(url).pipe(
            map((res: any) => res),
            catchError((err: any) => {
                return throwError(err.error);
            }),
        );
    }

    proceedToCreateNewDepartment(requestBody: {
        org_id: any;
        asset_ids: any;
        department_name: any;
        site_id: any;
    }) {
        let url: any;
        url = `${this.API_END_POINT}${apiConfig.department.createDepartment}`;
        return this.httpClient.post(url, requestBody);
    }

    getAssetDepartmentDetails(site_id: any) {
        let url;
        url =
            `${this.API_END_POINT}${apiConfig.department.getAssetDepartmentDetails}/` +
            site_id;
        return this.httpClient.get<any>(url).pipe(
            map((res: any) => res),
            catchError((err: any) => {
                return throwError(err.error);
            }),
        );
    }

    moveToOtherDepartment(requestBody: {
        destination_department_name: any;
        source_department_name: any;
        org_id: any;
        asset_ids: any;
        department_name: any;
        siteIds: any;
    }) {
        let url: any;
        url = `${this.API_END_POINT}${apiConfig.department.moveToOtherDepartment}`;
        return this.httpClient.post(url, requestBody);
    }

    // last surveyed on
    getLastSurveyDate(site_id: any) {
        return this.httpClient
            .get(
                `${this.API_END_POINT}${apiConfig.shiftData.getLastSurveyDate}/${site_id}`,
            )
            .pipe(
                map((res: any) => res),
                catchError((err: any) => {
                    return throwError(err.error);
                }),
            );
    }
    getSiteInformation(site_id: any) {
        return this.httpClient
            .get(
                `${this.API_END_POINT}${apiConfig.sla.getSiteInformation}/${site_id}`,
            )
            .pipe(
                map((res: any) => res),
                catchError((err: any) => {
                    return throwError(err.error);
                }),
            );
    }
    getSLADaysDetails(site_id: any) {
        return this.httpClient
            .get(
                `${this.API_END_POINT}${apiConfig.sla.getSLADaysDetails}/${site_id}`,
            )
            .pipe(
                map((res: any) => res),
                catchError((err: any) => {
                    return throwError(err.error);
                }),
            );
    }
    getIssueTypeData(site_id: any) {
        return this.httpClient
            .get(
                `${this.API_END_POINT}${apiConfig.shiftData.getIssueTypeData}/${site_id}`,
            )
            .pipe(
                map((res: any) => res),
                catchError((err: any) => {
                    return throwError(err.error);
                }),
            );
    }

    updateSiteInformation(
        day_start_time: any,
        day_end_time: any,
        night_start_time: any,
        night_end_time: any,
        speed_limit: any,
        site_ids: [],
    ) {
        let anomaly: any = {};
        anomaly.day_start_time = day_start_time;
        anomaly.day_end_time = day_end_time;
        anomaly.night_start_time = night_start_time;
        anomaly.night_end_time = night_end_time;
        anomaly.speed_limit = speed_limit ? speed_limit : 0;
        anomaly.site_ids = site_ids.toString();
        let url = `${this.API_END_POINT}${apiConfig.sla.updateSiteInformation}`;
        return this.httpClient.put(url, anomaly).pipe(
            map((res: any) => res),
            catchError((err: any) => {
                return throwError(err.error);
            }),
        );
    }

    updateSLADays(
        sla_days: number,
        asset_id: [],
        site_ids: any,
        department_name: any,
    ) {
        let anomaly: any = {};
        anomaly.asset_id = asset_id.toString();
        anomaly.site_ids = site_ids.toString();
        anomaly.sla_days = sla_days.toString();
        anomaly.department_name1 = department_name.toString();

        let url = `${this.API_END_POINT}${apiConfig.sla.updateSLADays}`;
        return this.httpClient.put(url, anomaly).pipe(
            map((res: any) => res),
            catchError((err: any) => {
                return throwError(err.error);
            }),
        );
    }

    addExclusionDetails(
        site_ids,
        requestBody: {
            period_from: any;
            period_to: any;
            start_chainage: any;
            end_chainage: any;
            asset_ids: any;
            reason: any;
            lhs_rhs: any;
            shoulder_median: any;
        },
    ) {
        let url: any;
        url = `${this.API_END_POINT}${apiConfig.exclusion.addExclusionDetails}/${site_ids}`;
        return this.httpClient.post(url, requestBody);
    }

    updateExclusionDetails(
        id,
        requestBody: {
            period_from: any;
            period_to: any;
            start_chainage: any;
            end_chainage: any;
            asset_ids: any;
            reason: any;
            lhs_rhs: any;
            shoulder_median: any;
        },
    ) {
        let url: any;
        url = `${this.API_END_POINT}${apiConfig.exclusion.updateExclusionDetails}/${id}`;
        return this.httpClient.put(url, requestBody);
    }

    get_all_site_exclusions(site_id: any, Status: string) {
        let url: any;
        url = `${this.API_END_POINT}${apiConfig.exclusion.getExclusionDetails}/${site_id}/${Status}`;
        return this.httpClient.get(url);
    }

    delete_exclusions(id: any) {
        let url: any;
        url = `${this.API_END_POINT}${apiConfig.exclusion.deleteExclusion}/${id}`;
        return this.httpClient.delete(url);
    }

    getAllReportsData(site_id: any) {
        let url: any;
        url = `${this.API_END_POINT}${apiConfig.reports.getAllReportsData}/${site_id}`;
        return this.httpClient.get(url);
    }

    manualClosure(formData: any) {
        let url: any;
        url = `${this.API_END_POINT}${apiConfig.workOrder.manulClose}`;
        return this.httpClient.post(url, formData);
    }

    getWeeklyReportData(site_id: any) {
        let url: any;
        url = `${this.API_END_POINT}${apiConfig.reports.get_weekly_reports}/${site_id}`;
        return this.httpClient.get(url);
    }

    getMonthlyReportData(site_id: any) {
        let url: any;
        url = `${this.API_END_POINT}${apiConfig.reports.get_monthly_reports}/${site_id}`;
        return this.httpClient.get(url);
    }

    getCategoryData(site_id: any) {
        let url: any;
        url = `${this.API_END_POINT}${apiConfig.masterData.getCategoryDetails}/${site_id}`;
        return this.httpClient.get(url);
    }

    private countdown: any; // Store interval reference
    time: any;

    calculateTime() {
        // Clear any existing interval before starting a new one
        if (this.countdown) {
            clearInterval(this.countdown);
        }

        this.countdown = setInterval(() => {
            this.time = Number(localStorage.getItem('countDown')); // Ensure it's a number

            if (this.time <= 0) {
                clearInterval(this.countdown);
                localStorage.setItem('countDown', '0');
            } else {
                this.time--;
                localStorage.setItem('countDown', this.time.toString());
            }
        }, 1000);
    }

    public reInitializeTimer() {
        this.time = Number(localStorage.getItem('countDown'));
        if (this.time <= 0) {
            this.authService.signOut().subscribe(() => {
                if (window.location.host === 'takeleap.in') {
                    window.location.href =
                        '/seekright-v2-development/#/sign-in';
                } else {
                    window.location.href = '/#/sign-in';
                }
            });
        } else {
            let countDown = 2700; // 45 minutes in seconds
            localStorage.setItem('countDown', countDown.toString());
            this.calculateTime();
        }
    }

    getEstimatedTimeDetails(
        isUnique: any,
        asset_ids: any,
        periodFrom: any,
        periodTo: any,
        date: any,
        site_ids: any,
    ) {
        let url;
        if (asset_ids.length == 0) {
            url = `${this.ANTON_API_END_POINT}${apiConfig.reports.get_estimated_time_reports}?isUnique=${isUnique}&periodFrom=${periodFrom}&periodTo=${periodTo}&date=${date}&site_ids=${site_ids}`;
        }
        if (periodFrom == null && periodTo == null) {
            url = `${this.ANTON_API_END_POINT}${apiConfig.reports.get_estimated_time_reports}?isUnique=${isUnique}&asset_ids=${asset_ids}&date=${date}&site_ids=${site_ids}`;
        }
        if (periodFrom == null && periodTo == null && asset_ids.length == 0) {
            url = `${this.ANTON_API_END_POINT}${apiConfig.reports.get_estimated_time_reports}?isUnique=${isUnique}&date=${date}&site_ids=${site_ids}`;
        } else if (
            periodFrom != null &&
            periodTo != null &&
            asset_ids.length > 0
        ) {
            url = `${this.ANTON_API_END_POINT}${apiConfig.reports.get_estimated_time_reports}?isUnique=${isUnique}&asset_ids=${asset_ids}&periodFrom=${periodFrom}&periodTo=${periodTo}&date=${date}&site_ids=${site_ids}`;
        }
        return this.httpClient.get<any>(url).pipe(
            map((res: any) => res),
            catchError((err: any) => {
                return throwError(err.error);
            }),
        );
    }

    getDashboardBarPlotData(site_id) {
        let params = this.generateHttpParams({
            site_id: site_id,
        });
        return this.httpClient
            .get(
                `${this.API_END_POINT}${apiConfig.dashboardWidgets.totalWidgetsBarPlot}`,
                { params },
            )
            .pipe(
                map((res: any) => res),
                catchError((err: any) => {
                    return throwError(err.error);
                }),
            );
    }

    getDashboardChartData(site_id) {
        let params = this.generateHttpParams({
            site_id: site_id,
        });
        return this.httpClient
            .get(
                `${this.API_END_POINT}${apiConfig.dashboardWidgets.totalWidgetsCharts}`,
                { params },
            )
            .pipe(
                map((res: any) => res),
                catchError((err: any) => {
                    return throwError(err.error);
                }),
            );
    }

    markRecordDownloaded(id: any) {
        const url = `${this.API_END_POINT}${apiConfig.dashboardWidgets.recordDownloaded}/${id}`;
        return this.httpClient.post(url, {}).pipe(
            map((res: any) => res),
            catchError((err: any) => {
                return throwError(err.error);
            }),
        );
    }

    getLanguagesDetails(site_id: any) {
        this.getLanguages(site_id).subscribe((res) => {
            localStorage.setItem('getLanguagesCallCount', '1');
            this.availableLangs = res.responseData[0].records;
            localStorage.setItem(
                'languages',
                JSON.stringify(this.availableLangs),
            );
        });
    }

    getAllUserDetails(org_id: any) {
        const url = `${this.API_END_POINT}${apiConfig.user.getAllUserDetails}/${org_id}`;
        return this.httpClient.get(url, {}).pipe(
            map((res: any) => res),
            catchError((err: any) => {
                return throwError(err.error);
            }),
        );
    }

    getAllDepartmentsDetails(site_ids: any) {
        const url = `${this.API_END_POINT}${apiConfig.user.getAllDepartmentsDetails}/${site_ids}`;
        return this.httpClient.get(url, {}).pipe(
            map((res: any) => res),
            catchError((err: any) => {
                return throwError(err.error);
            }),
        );
    }

    addNewUser(requestBody: {
        name: any;
        email: any;
        password: any;
        org_id: any;
        db_name: any;
        site_ids: any;
        department_ids: any;
        roles: any;
        report_role: any;
    }) {
        let url: any;
        url = `${this.API_END_POINT}${apiConfig.user.addNewUser}`;
        let headers = new HttpHeaders({
            timeout: '600000',
        });
        return this.httpClient.post(url, requestBody, { headers });
    }

    updateSelectedMap(userId: any, selectedMap: string) {
        const url = `${this.API_END_POINT}${apiConfig.user.updateSelectedMap}`;
        return this.httpClient.post(url, { selected_map: selectedMap });
    }

    addNewAnomalyDetails(
        master_id: any,
        asset_id: any,
        site_id: any,
        chainage: any,
        latitude: any,
        longitude: any,
        lhs_rhs: any,
        remark: any,
        comment: any,
        test_image_path: any,
        master_image_path: any,
        asset_type: any,
        both_site_ids: any,
        department_id: any,
    ) {
        const formData = new FormData();
        if (master_image_path) {
            formData.append('master_image_path', master_image_path);
        }
        if (test_image_path) {
            formData.append('test_image', test_image_path);
        }
        let url: any;
        url = `${this.API_END_POINT}${apiConfig.masterData.addNewAnomaly}?master_id=${master_id}&asset_id=${asset_id}&site_id=${site_id}&chainage=${chainage}
        &latitude=${latitude}&longitude=${longitude}&lhs_rhs=${lhs_rhs}&remark=${remark}&comment=${comment}&asset_type=${asset_type}&both_site_ids=${both_site_ids}
        &department_id=${department_id}&created_by=${this.loggedInUser.user_id}`;
        return this.httpClient.post(url, formData);
    }

    getmasterDetailForPreview(site_ids: any, chainage: any, asset_id: any) {
        let url = `${this.API_END_POINT}${apiConfig.masterData.getmasterDetailsForPreview}?site_ids=${site_ids}&chainage=${chainage}&asset_id=${asset_id}`;
        return this.httpClient.get(url, {}).pipe(
            map((res: any) => res),
            catchError((err: any) => {
                return throwError(err.error);
            }),
        );
    }

    getMCWServiceLaneValue(): boolean {
        let displayMCWServiceLaneToggle: boolean = false;
        let permission: any = localStorage.getItem('permissions');
        if (permission != null && permission != '' && permission != undefined) {
            permission = JSON.parse(permission);
            permission.forEach((p: any) => {
                if (p.permissions.keyname === 'Road_Types') {
                    displayMCWServiceLaneToggle = true;
                    return;
                }
            });
        }
        return displayMCWServiceLaneToggle;
    }

    getWorkOrderFilter(
        search: any,
        chainageRange: any = [],
        isDayNight: any = 'both',
        issueType: any,
    ) {
        /*WO anomaly and completed filter changes */
        let manual_anomalies: any = 0;
        let AI_rejected: any = 0;
        let detected: any = 0;
        search?.detectionStatus.forEach((element) => {
            if (element === 'manualSelected') {
                manual_anomalies = 1;
            }
            if (element === 'aiRejectedSelected') {
                AI_rejected = 1;
            }
            if (element === 'detectedSelected') {
                detected = 1;
            }
        });
        search.UIType?.forEach((type: any, index: number) => {
            if (type == 'manualClosedSelected') {
                search.UIType[index] = 'manualClosed';
            }
            if (type == 'aiReviewSelected') {
                search.UIType[index] = 'aiReview';
            }
        });
        if (this.loggedInUser.org_id === 192) {
            delete search.chainage;
        }
        delete search.issueType;
        const encodedChainage = encodeURIComponent(
            JSON.stringify(chainageRange),
        );
        let params = this.generateHttpParams(search);
        let url = '';
        /*WO anomaly and completed filter changes */
        const isEmpty = (val: any) =>
            val === null ||
            val === undefined ||
            val === '' ||
            val === ' ' ||
            val === '[]' ||
            val === '{}' ||
            (Array.isArray(val) && val.length === 0);
        const isChainageEmpty = isEmpty(chainageRange);
        const isIssueTypeEmpty = isEmpty(issueType);
        const includeDayNight = isDayNight !== 'both';

        let query = `${params}`;
        console.log(params);
        if (!isChainageEmpty) query += `&chainageRange=${encodedChainage}`;
        if (!isIssueTypeEmpty) query += `&issueType=${issueType}`;
        if (includeDayNight) query += `&isDayNight=${isDayNight}`;
        if (search.closureType.length === 1) {
            search.closureType[0] === 'autoClosedSelected'
                ? (query += `&auto_close_anomalies=1`)
                : (query += `&auto_close_anomalies=0`);
        }
        query += `&manual_anomalies=${manual_anomalies}&AI_rejected=${AI_rejected}&detected=${detected}`;
        url = `${this.API_END_POINT}${apiConfig.shiftData.getWorkOrderFilter}?${query}`;
        return this.httpClient.get(url).pipe(
            map((res: any) => res),
            catchError((err: any) => {
                return throwError(err.error);
            }),
        );
    }

    deleteUsers(user_id: any) {
        const url = `${this.API_END_POINT}${apiConfig.user.deleteUsers}?user_id=${user_id}`;
        return this.httpClient.delete(url, {}).pipe(
            map((res: any) => res),
            catchError((err: any) => {
                return throwError(err.error);
            }),
        );
    }
}
